function AccountsFindIdCtrl($scope, $state, $rootScope, $q, $window, toastr, UserService, AuthService, AppSettings) {
    'ngInject';

    const vm = this;

    $scope.vm = vm;

    vm.isMobile = window.mobilecheck();

    const currentYear = (new Date()).getFullYear();

    vm.years = _.range(1940, currentYear);
    vm.months = _.range(1, 13);
    vm.dates = _.range(1, 32);

    vm.findIdData = {
        name: null,
        birth: null,
        birthdate: {
            year: '' + (currentYear - 20),
            month: '1',
            date: '1'
        }
    };

    vm.loginIds = [];

    // 생년월일 변경
    $scope.$watchCollection('vm.findIdData.birthdate', function (newVal, oldVal) {
        if (newVal.year && newVal.month && newVal.date) {
            let month = newVal.month;
            let date = newVal.date;

            if (month < 10) {
                month = '0' + month;
            }
            if (date < 10) {
                date = '0' + date;
            }

            vm.findIdData.birth = newVal.year + month + date;
        }
    });

    vm.submit = function () {
        UserService.findId(vm.findIdData).then(function (res) {
            if (res.data.result === 'NOT') {
                toastr.error('아이디가 존재하지 않습니다.');
                vm.loginIds = [];
            } else {
                vm.loginIds = res.data.list;
            }
        });
    };

}

export default {
    name: 'AccountsFindIdCtrl',
    fn: AccountsFindIdCtrl
};
